// firebase.js - Runtime configuration fetching
import { initializeApp, getApps } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

let firebaseApp = null;
let auth = null;
let db = null;
let storage = null;
let googleProvider = null;

// Function to initialize Firebase with server-provided config
async function initializeFirebase() {
  if (firebaseApp) {
    return firebaseApp; // Already initialized
  }

  try {

    
    const response = await fetch('/api/config/firebase-config');
    if (!response.ok) {
      throw new Error(`Failed to fetch Firebase config: ${response.statusText}`);
    }
    
    const firebaseConfig = await response.json();

    // Validate Firebase config structure
    const requiredFields = ['apiKey', 'authDomain', 'projectId', 'storageBucket', 'appId'];
    const missingFields = requiredFields.filter(field => !firebaseConfig[field] || firebaseConfig[field] === 'undefined');
    
    if (missingFields.length > 0) {

      throw new Error(`Missing Firebase config fields: ${missingFields.join(', ')}`);
    }

    // Ensure all config values are strings and not 'undefined'
    Object.keys(firebaseConfig).forEach(key => {
      if (firebaseConfig[key] === 'undefined' || firebaseConfig[key] === null) {

        throw new Error(`Firebase config field ${key} is undefined`);
      }
    });



    // Initialize Firebase
    firebaseApp = getApps().length === 0 ? initializeApp(firebaseConfig) : getApps()[0];
    
    // Initialize services
    auth = getAuth(firebaseApp);
    db = getFirestore(firebaseApp);
    storage = getStorage(firebaseApp);
    googleProvider = new GoogleAuthProvider();
    
    // Configure Google provider
    googleProvider.addScope('profile');
    googleProvider.addScope('email');
    

    return firebaseApp;
  } catch (error) {

    throw error;
  }
}

// Export a promise that resolves when Firebase is ready
export const firebaseReady = initializeFirebase();

// Export getter functions that wait for initialization
export const getFirebaseAuth = async () => {
  await firebaseReady;
  return auth;
};

export const getFirebaseDB = async () => {
  await firebaseReady;
  return db;
};

export const getFirebaseStorage = async () => {
  await firebaseReady;
  return storage;
};

export const getGoogleProvider = async () => {
  await firebaseReady;
  return googleProvider;
};

// Export for compatibility with existing code
export { auth, db, storage, googleProvider };

export default firebaseApp;